/**
 * @module ui/Hoc
 */

export { hydrateProps } from './hydrateProps.js';
